export const appendTextFields = (
  formData: FormData,
  fields: Record<string, unknown>,
  omit: string[] = [],
): void => {
  Object.entries(fields).forEach(([key, value]) => {
    if (omit.includes(key) || value === null || value === undefined) return;
    formData.append(
      key,
      typeof value === "object" ? JSON.stringify(value) : String(value),
    );
  });
};
